import './TextLink.sass';

import PropTypes from 'prop-types';
import React from 'react';

export default class TextLink extends React.Component {
  render() {
    return (
      <div
        className="TextLink"
        style={this.props.style}
        onClick={this.props.onAction}
      >
        <div className="Text">{this.props.text}</div>
      </div>
    );
  }
}

TextLink.propTypes = {
  text: PropTypes.string,
  onAction: PropTypes.func,
  style: PropTypes.shape({}),
};

TextLink.defaultProps = {
  style: { textAlign: 'center' },
};
